module.exports = __webpack_public_path__ + "static/mini_jaune-87cfaf2140ea41d90851eba4a304debb.jpg";